module.exports = "https://cdn.littlereply.com/tt/resource/nav_icon_close.845f98af4f5003ded8461b16e289261c.png";